import { Controller } from '@hotwired/stimulus'
import { post } from '@rails/request.js'

export default class extends Controller {
  static targets = ['form', 'assessmentMessage', 'conflictMessage']

  static get values () {
    return {
      checkEndpoint: String,
      nextStep: String
    }
  }

  connect () {
    this.assessmentMade = false
    this.conflictMessageShown = false
    this.submitted = false
  }

  continueButtonClicked (event) {
    event.preventDefault()

    if (this.formTarget.checkValidity()) {
      if (this.canShowConflictMessage()) {
        this.conflictMessageShown = true
        this.showConflictMessage()
      }

      if (!this.submitted) {
        if (this.assessmentMade) {
          this.submitted = true
          this.submitForm()
        } else {
          this.checkForm()
        }
      }
    }
  }

  async checkForm () {
    const formData = new FormData(this.formTarget)
    const result = await post(this.checkEndpointValue, {
      body: formData
    })

    const json = await result.response.json()
    this.makeAssessment(json)
  }

  async submitForm () {
    const formData = new FormData(this.formTarget)
    await post(this.formTarget.action, {
      body: formData
    })

    this.redirectToNextStep()
  }

  canShowConflictMessage () {
    return !this.conflictMessageShown && this.hasConflictingAnswers()
  }

  hasConflictingAnswers () {
    return this.formTarget.querySelectorAll('input[type="radio"]:checked[data-conflicting="true"]').length === 1
  }

  showConflictMessage () {
    this.conflictMessageTarget.classList.remove('hidden')
  }

  redirectToNextStep () {
    window.location.href = this.nextStepValue
  }

  resetMessages () {
    this.assessmentMessageTarget.classList.add('hidden')
    this.assessmentMade = false
    this.conflictMessageTarget.classList.add('hidden')
    this.conflictMessageShown = false
  }

  makeAssessment (data) {
    this.assessmentMade = true
    if (data.assessment === 'unsophisticated') {
      this.assessmentMessageTarget.classList.remove('hidden')
    } else {
      this.submitForm()
    }
  }
}
